import React from "react";
import {Col, Row, FormGroup, Container} from "react-bootstrap";
import { Form, Input, Radio, Checkbox, DatePicker, Select } from 'antd';
import { Breadcrumb, ImageElement, LoginHeader} from "../../components";
import { Link } from "react-router-dom";

function PaynowPayment() {

    const breadcrumb = [
        {
            path: '/dashboard',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Payment',
        },
    ];

    return(
        <>            
            <LoginHeader/>         
            <div className="main-content paymentPage">
                {/* page content */}
                <div className="pageContent">
                    <div className="pageContent_wide">
                        <Container className="container-lg">
                            <Breadcrumb title="Payment" breadcrumb={breadcrumb}/>
                            {/* Payment page content */}
                            <div className="br-10 p-30 bg-white">
                                <div className="paymentPage_head d-flex align-items-center justify-content-between flex-wrap">
                                    <div>
                                        <h2 className="text-850 font-sm paymentPage_head_title mb-0">Saved Card</h2>
                                        <span>Select your card</span>
                                    </div>
                                    <div><p className="font-md paymentPage_amount mb-0">Payment amount</p>
                                    <h3 className="paymentPage_price font-sm text-500  mb-0">$ 255.00</h3></div>
                               </div>
                                
                               <Radio.Group name="radiogroup" defaultValue={1}>
                               <div className="paymentPage_card form-group">
                                    <div className="d-flex">
                                        <Form className="w-100">
                                            <div className="d-flex align-items-center justify-content-between">                                                
                                                <FormGroup className="form-group mb-0 me-xxl-3 me-sm-2 me-1 ">
                                                <Radio value={1}></Radio>
                                                </FormGroup>   
                                                <div className="flex-grow-1 font-md">Steven Hurd<span className="paymentPage_card_no d-block  font-md">**** **** **** 1234</span> </div>
                                                <ImageElement className="img-fluid paymentPage_card_logo" source="mastercard-logo.png" alt="logo" />
                                            </div>
                                        </Form>
                                    </div>
                                </div>
                                 {/* Payment Visa card */}
                               <div className="paymentPage_card form-group">
                                    <div className="d-flex">
                                        <Form className="w-100">
                                            <div className="d-flex align-items-center justify-content-between">                                                
                                                <FormGroup className="form-group mb-0 me-xxl-3 me-sm-2 me-1 ">
                                                <Radio value={2}></Radio>
                                                </FormGroup>   
                                                <div className="flex-grow-1 font-md">Steven Hurd<span className="paymentPage_card_no d-block  font-md">**** **** **** 1234</span> </div>
                                                <ImageElement className="img-fluid paymentPage_card_logo" source="visa-logo.png" alt="logo" />
                                            </div>
                                        </Form>
                                    </div>
                                </div>
                                 {/* Payment page Card */}
                               <div className="paymentPage_card form-group">
                                    <div className="d-flex">
                                        <Form className="w-100">
                                            <div className="d-flex">                                                
                                                <FormGroup className="form-group mb-0 me-xxl-3 me-sm-2 me-1 ">
                                                <Radio value={3} checked></Radio>
                                                </FormGroup>   
                                                <div className="flex-grow-1 font-md">Pay With New Card</div>
                                            </div>
                                            <div className="paymentPage_card_form" >
                                                <Row>
                                                    <Col sm={12}>
                                                        <FormGroup className="form-group">
                                                            <label className="ant-label ">Card Holder Name</label>
                                                            <Input type="text" size="large" placeholder="Card Holder Name" />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={12}>
                                                        <FormGroup className="form-group">
                                                            <label className="ant-label">Card Number</label>
                                                            <div className="position-relative">
                                                                <Input type="text" size="large" className="cardnumber" placeholder="Card Number" />
                                                                <ImageElement className="img-fluid input-img" source="visa-logo.png" alt="logo" />
                                                            </div>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <FormGroup className="form-group">
                                                            <label className="ant-label">Exp. Month</label>
                                                            <Select size="large" className="w-100" placeholder="Month"
                                                                options={[
                                                                    {
                                                                        value: '01',
                                                                        label: '01',
                                                                    },
                                                                    {
                                                                        value: '02',
                                                                        label: '02',
                                                                    },
                                                                    {
                                                                        value: '03',
                                                                        label: '03',
                                                                    },
                                                                    {
                                                                        value: '04',
                                                                        label: '04',
                                                                    },
                                                                    {
                                                                        value: '05',
                                                                        label: '05',
                                                                    },
                                                                    {
                                                                        value: '06',
                                                                        label: '06',
                                                                    },
                                                                    {
                                                                        value: '07',
                                                                        label: '07',
                                                                    },
                                                                    {
                                                                        value: '08',
                                                                        label: '08',
                                                                    },
                                                                    {
                                                                        value: '09',
                                                                        label: '09',
                                                                    },
                                                                    {
                                                                        value: '10',
                                                                        label: '10',
                                                                    },
                                                                    {
                                                                        value: '11',
                                                                        label: '11',
                                                                    },
                                                                    {
                                                                        value: '12',
                                                                        label: '12',
                                                                    },
                                                                ]}
                                                            />
                                                        </FormGroup>
                                                    </Col> 
                                                    <Col sm={6}>
                                                        <FormGroup className="form-group">
                                                            <label className="ant-label">Exp. Year</label>
                                                            <Select size="large" className="w-100" placeholder="Year"
                                                                options={[
                                                                    {
                                                                        value: '2023',
                                                                        label: '2023',
                                                                    },
                                                                    {
                                                                        value: '2024',
                                                                        label: '2024',
                                                                    },
                                                                    {
                                                                        value: '2024',
                                                                        label: '2024',
                                                                    },
                                                                    {
                                                                        value: '2025',
                                                                        label: '2025',
                                                                    },
                                                                    {
                                                                        value: '2026',
                                                                        label: '2026',
                                                                    },
                                                                    {
                                                                        value: '2027',
                                                                        label: '2027',
                                                                    },
                                                                ]}
                                                            />
                                                        </FormGroup>
                                                    </Col> 
                                                    <Col sm={12}>
                                                        <FormGroup className="form-group">
                                                            <label className="ant-label">CVV</label>
                                                            <Input type="text" size="large" placeholder="CVV" />
                                                        </FormGroup>
                                                    </Col>  
                                                    <Col sm={12} className="mt-2">
                                                        <FormGroup className="form-group">
                                                            <Checkbox>Save this card to make your payments easy</Checkbox>
                                                        </FormGroup>
                                                    </Col>   
                                                </Row>
                                            </div>
                                        </Form>
                                    </div>
                                </div>                                
                            </Radio.Group>
                                
                            <div className="d-flex justify-content-end">
                                        <Link to="/rating" className="font-sm btn btn-primary min-200 btn-lg">Pay Now</Link>
                                    </div>
                            </div>
                        </Container>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PaynowPayment;